<template>
  <div class="layout">
    <Header />
    <Content />
    <Footer />
  </div>
</template>

<script>
import Content from "./Content.vue"
import Footer from "./Footer.vue"
import Header from "./Header.vue"

export default {
  components: {
    Header,
    Content,
    Footer
  }
}
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.header {
  height: 50px;
}

.content {
  flex-grow: 1;
}

.footer {
  height: 24px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/layout/desktop/Layout.vue